import {
  RESPONSE_CARS_GROUPS,
  REQUEST_CARS_GROUPS_FAILURE,
} from '../actions/carsGroupsActions'

import { states as queriesStates } from './queriesStates'

const initialState = {
  dataState: queriesStates.NOT_REQUESTED,
  groups: []
}

const carsGroupsReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESPONSE_CARS_GROUPS: {
      return Object.assign(
        {},
        state,
        {
          dataState: queriesStates.READY,
          groups: action.data
        }
      )
    }
    case REQUEST_CARS_GROUPS_FAILURE: {
      return Object.assign(
        {},
        state,
        {
          dataState: queriesStates.FAILURE,
          errors: action.errors,
        }
      )
    }
    default:
      return state
  }
}

export default carsGroupsReducer
